export enum IdentityProvider {
  AX_AUTH = 'AX_AUTH',
  AZURE_AD = 'AZURE_AD',
  GOOGLE = 'GOOGLE',
  AXINOM = 'AXINOM',
  CUSTOM = 'CUSTOM',
}

export enum TokenResponseCode {
  SUCCESS,
  NEEDS_LOGIN,
  ACCOUNT_NOT_ACTIVE,
  ERROR,
}

export enum LogoutResponseCode {
  SUCCESS,
  ERROR,
}

export enum ConfigStatusResponseCode {
  SUCCESS = 'SUCCESS',
  TENANT_NOT_ACTIVE = 'TENANT_NOT_ACTIVE',
  ENVIRONMENT_NOT_ACTIVE = 'ENVIRONMENT_NOT_ACTIVE',
  IDP_MISCONFIGURATION = 'IDP_MISCONFIGURATION',
  ERROR = 'ERROR',
}
